module.exports = __webpack_public_path__ + "35aad1c3713f523d182bd8771e6a12aa.pdf";